import { AlertCircle } from 'lucide-react';

/**
 * Shown by the quote/move shells when the org's inventory failed to load.
 * Without inventory, item pickers are empty and the formula engine cannot
 * price the job, so the failure must be visible rather than silent.
 */
export function OrgInventoryErrorBanner({ message }: { message: string }) {
  return (
    <div
      role="alert"
      className="mx-4 mt-4 flex items-start gap-2 px-4 py-3 rounded-xl bg-rose/10 border border-rose/30"
    >
      <AlertCircle size={15} className="shrink-0 text-rose mt-0.5" />
      <p className="text-small text-rose">
        <span className="font-semibold">Couldn&apos;t load your organization&apos;s inventory.</span>{' '}
        Item lists and pricing will be incomplete until it loads. {message}
      </p>
    </div>
  );
}
